//editor est l'userId
export default (rdv, editor, timestamp, mode) => {
    return { ...rdv, log: { created: { editor, timestamp, mode } } };
};
//# sourceMappingURL=editLog.js.map